export const CHECKUID_FORCE_LOWERCASE = false;